// extracted by mini-css-extract-plugin
export var optionGrid = "_40-7";
export var optionList = "_40-6";
export var questionsBlock = "_40-9";
export var spacer = "_40-5";
export var stepCenteredContent = "_40-3";
export var stepInner = "_40-0";
export var stepInnerFullWidth = "_40-1";
export var stepInnerLockScroll = "_40-2";
export var stepTransitionFrame = "_40-4";
export var welcomeBlock = "_40-8";